module.exports = __webpack_public_path__ + "static/media/scotiabankuruguay.b9b22438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scotiabankuruguay.jpg
// module id = 491
// module chunks = 0 1 2